export default __webpack_public_path__ + "static/media/second-right-img@2x.87c968cc.webp";